import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { createBrowserHistory } from "history";
import App from "./components/App";

// This import loads the firebase namespace along with all its type information.
import firebase from "firebase/compat/app";

// These imports load individual services into the firebase namespace.
import "firebase/compat/messaging";
import { FIREBASE_CONFIG } from "firebaseConfig";
import { configLogger } from "services/logging";
import Configuration from "./config";

firebase.initializeApp(FIREBASE_CONFIG);

if (Configuration.ENABLE_LOGGING) {
  configLogger();
}

const history = createBrowserHistory();

export default function AppContainer() {
  let router = createBrowserRouter(
    createRoutesFromElements(<Route path={"*"} element={<App />} />)
  );

  return <RouterProvider router={router} />;
}

export function getHistory() {
  return history;
}
